import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { getCmdbGlobalConfigObjectUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/global.tsx';
import { isSignal } from '@atlassian/jira-servicedesk-insight-shared-utils/src/common/utils/use-fetch-error/index.tsx';
import type { Action } from '@atlassian/react-sweet-state';
import type {
	InsightObjectViewState,
	ObjectConfigRestResponse,
	ContainerProps,
} from '../../../../common/types/index.tsx';

export const fetchObjectConfiguration =
	(): Action<InsightObjectViewState, ContainerProps> =>
	async ({ getState, setState }, { workspaceId, createAnalyticsEvent }) => {
		try {
			const { objectDetails } = getState();

			const { objectType } = objectDetails ?? {};
			const { objectSchemaId, id: objectTypeId } = objectType ?? {};

			if (objectSchemaId && objectTypeId) {
				const objectConfiguration: ObjectConfigRestResponse = await performGetRequest(
					getCmdbGlobalConfigObjectUrl(workspaceId, {
						objectschemaid: objectSchemaId,
						objecttypeid: objectTypeId,
					}),
				);

				setState({ objectConfiguration });
				fireTrackAnalytics(createAnalyticsEvent({}), 'fetchInsightObjectConfiguration succeeded');
			}
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({ error });
			if (isSignal(error)) {
				fireErrorAnalytics({
					meta: {
						id: 'fetchInsightObjectConfiguration',
						packageName: 'jiraServicedeskInsightObjectDetailsStore',
						teamName: 'falcons',
					},
					error,
				});
			}
		}
	};
